// letterConstants.ts
// Shared constants for the letter editor — imported by both
// SchoolLetterHeader.tsx and TemplateSetupPanel.tsx to avoid circular deps.

export const PAGE_W = 794;
export const PAGE_H = 1123;
export const SNAP = 4;
export const ZOOM_STEPS = [0.25, 0.33, 0.5, 0.67, 0.75, 0.9, 1.0, 1.1, 1.25, 1.5, 1.75, 2.0];
export const FONT_SIZES = [8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 24, 28, 32, 36];
